module.exports = __webpack_public_path__ + "img/tijiao_ok_img@2x.00b72888.png";